(function () {
  if (window.__universeCarouselInit) return;
  window.__universeCarouselInit = true;

  function initCarousel() {
    if (window.innerWidth < 990) return;

    const section = document.querySelector('#shopify-section-template--29153375191414__universe-nav');
    if (!section) return;

    const list = section.querySelector('.multicolumn-list');
    if (!list || list.closest('.universe-carousel-track')) return;

    // Track wrapper
    const track = document.createElement('div');
    track.className = 'universe-carousel-track';
    list.parentNode.insertBefore(track, list);
    track.appendChild(list);

    // Flèches
    const prevBtn = document.createElement('button');
    prevBtn.className = 'universe-carousel-btn universe-carousel-btn--prev';
    prevBtn.setAttribute('aria-label', 'Précédent');
    prevBtn.innerHTML = '&#8249;';

    const nextBtn = document.createElement('button');
    nextBtn.className = 'universe-carousel-btn universe-carousel-btn--next';
    nextBtn.setAttribute('aria-label', 'Suivant');
    nextBtn.innerHTML = '&#8250;';

    track.appendChild(prevBtn);
    track.appendChild(nextBtn);

    let currentIndex = 0;

    function getItemWidth() {
      const item = list.querySelector('.multicolumn-list__item');
      return item ? item.getBoundingClientRect().width + 16 : 236;
    }

    function getVisibleCount() {
      return Math.floor(track.getBoundingClientRect().width / getItemWidth());
    }

    function getTotalItems() {
      return list.querySelectorAll('.multicolumn-list__item').length;
    }

    function getMaxIndex() {
      // S'arrête exactement quand le dernier élément est visible
      const total = getTotalItems();
      const visible = getVisibleCount();
      const itemW = getItemWidth();
      const trackW = track.getBoundingClientRect().width;
      const totalContentWidth = total * itemW - 16; // retire le gap du dernier
      const maxScroll = totalContentWidth - trackW;
      return Math.ceil(maxScroll / itemW);
    }

    function updateCarousel() {
      const itemW = getItemWidth();
      const maxIndex = getMaxIndex();
      currentIndex = Math.min(currentIndex, maxIndex);
      list.style.transform = `translateX(-${currentIndex * itemW}px)`;
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    nextBtn.addEventListener('click', () => {
      if (currentIndex < getMaxIndex()) {
        currentIndex++;
        updateCarousel();
      }
    });

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });

    updateCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousel);
  } else {
    initCarousel();
  }
})();
